import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export default function CheckIn({ event }) {
  const { id } = useParams();
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [participant, setParticipant] = useState(null);
  const [message, setMessage] = useState(null);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    fetch(`/api/events/${event.event_slug}/checkin/${id}/`)
      .then((res) => res.json())
      .then((data) => {
        setParticipant(data);
      })
      .catch((err) => console.log(err));
  }, [event.event_slug, id]);

  const submitVerification = async (e) => {
    e.preventDefault();

    const response = await fetch(
      `/api/events/${event.event_slug}/checkin/login/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      },
    );

    const data = await response.json();

    if (data.error) {
      setMessage({ type: "error", text: data.error });
    } else {
      setMessage({ type: "success", text: data.message });
      localStorage.setItem("CHECKIN_TOKEN", data.checkin_token);
      setShowLoginForm(false);
    }
  };

  const handleQuickVerify = async () => {
    const token = localStorage.getItem("CHECKIN_TOKEN");

  if (!token || token === "undefined" || token === "null") {
    localStorage.removeItem("CHECKIN_TOKEN");
    setShowLoginForm(true);
    return;
  }

    const response = await fetch(
      `/api/events/${event.event_slug}/attendance/${id}/verify/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      },
    );

    const data = await response.json();

    if (data.error) {
      setMessage({ type: "error", text: data.error });
    } else {
      setMessage({ type: "success", text: data.message });
    }
  };

  return (
    <>
      <div className="max-w-5xl mx-auto text-center px-4 mb-12">
        <h3 className="text-3xl font-bold text-gray-900 leading-tight">
          CheckIn
        </h3>
      </div>
      {/* User Details */}
      <div className="flow-root">
        <dl className="-my-3 divide-y divide-gray-200 text-sm *:even:bg-gray-50">
          <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
            <dt className="font-medium text-gray-900">Full Name</dt>

            <dd className="text-gray-700 sm:col-span-2">
              {participant
                ? `${participant.first_name} ${participant.last_name}`
                : "Loading..."}
            </dd>
          </div>

          <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
            <dt className="font-medium text-gray-900">Organization</dt>

            <dd className="text-gray-700 sm:col-span-2">
              {participant ? participant.organization : "Loading..."}
            </dd>
          </div>

          <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4 mb-4">
            <dt className="font-medium text-gray-900">Attendance Type</dt>

            <dd className="text-gray-700 sm:col-span-2">
              {participant ? participant.attendance_type : "Loading..."}
            </dd>
          </div>
        </dl>
        {/* Message */}
        {message && (
          <div
            className={`mt-4 p-3 rounded ${
              message.type === "success"
                ? "bg-green-200 text-green-800"
                : "bg-red-200 text-red-800"
            }`}
          >
            {message.text}
          </div>
        )}
        <button
          onClick={handleQuickVerify}
          className="block w-full  border  bg-[#0166b1] px-12 py-3 text-sm font-medium text-white transition-colors hover:bg-transparent hover:text-green-600"
          type="submit"
        >
          Verify & Check In
        </button>
      </div>
      {/* Login Form */}
      {showLoginForm && (
        <div className="bg-gradient-to-b from-[#b9d5eb] to-white mt-10 p-6">
          <form onSubmit={submitVerification}>
            <div className="mx-auto grid max-w-lg grid-cols-1 gap-6 rounded-lg border border-gray-300 bg-gray-100 p-6  mt-10">
              <div>
                <label
                  className="block text-sm font-medium text-gray-900"
                  htmlFor="username"
                >
                  Username
                </label>
                <input
                  className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-black p-2"
                  id="username"
                  type="text"
                  placeholder="Admin Username"
                  required
                  shadow
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div>
                <label
                  className="block text-sm font-medium text-gray-900"
                  htmlFor="password"
                >
                  Password
                </label>
                <input
                  className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-black p-2"
                  id="password"
                  type="password"
                  required
                  shadow
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <button
                className="block w-full  border  bg-[#0166b1] px-12 py-3 text-sm font-medium text-white transition-colors hover:bg-transparent hover:text-green-600"
                type="submit"
              >
                Check IN
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
